const sanitizeText = string => string.replace(/\r\n|\r|\n/g, '<br/>')

export default sanitizeText
